import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { format } from "date-fns";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL, reportLetter, UnicodeCompany } from "../../../global";
import { fetchAddresses, fetchQuery } from "../../../utils/commonComponent/fetched";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import Text from "../../../utils/Custom/text";
import { AutoCompletes, TextFields, DateInput } from "../../../utils/Custom/custominput";
import ProductDetails from "../../productDetails/productDetails";
import { clienTypes } from "../../../utils/commonComponent/common";
import DownloadPdfLoaderModal from "../../../utils/commonComponent/downloadPdfLoader";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../../utils/commonComponent/errorAlert";

const gstTypes = [
  { id: 1, label: "State GST" },
  { id: 2, label: "Central Gst" },
  { id: 3, label: "Non Gst" },
];

let gstPercentageOptions = [
  { id: 18, label: "18" },
  { id: 20, label: "20" },
  { id: 28, label: "28" },
  { id: 15, label: "15" },
];

// getInputFields()).
const formFieldKeys = ["clientId","address","contact","contactNumber","emailId","contactDept","contactPerson","quotationNumber","date","gstType","gstpercentages","enquiryReference","refNoEnquiry"];
// Builds the same JSON-array shape used by the clients table's `contact`
// column, so quotation.contactPerson stays consistent with that format.
const buildContactPersonJSON = (dept, contactPersonName, contact, emailId) => {
  return JSON.stringify([
    {
      dept: dept || "",
      contactPersonName: contactPersonName || "",
      contact: contact || "",
      emailId: emailId || "",
    },
  ]);
};

export default function EditQuotation(props) {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const PrintView = props?.print == true;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fromEnquiryId = searchParams.get("fromEnquiry");

  const [inputStates, setInputStates] = React.useState({});
  const [letterHead, setLetterHead] = React.useState(true);
  const [changeHistory, setChangeHistory] = React.useState([]);
  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);
  const userType = localStorage.getItem("type");
  const userId = localStorage.getItem("id");
  const [employeeList, setEmployeeList] = React.useState([]);
  const [technicalEmployeeList, setTechnicalEmployeeList] = React.useState([]);

  const [quotationObject, updateQuotationObject] = React.useState({});


  const [clientList, setClientList] = React.useState([]);
  const [productDetails, setProductDetails] = React.useState([]);
  // Address management
  const [availableAddresses, setAvailableAddresses] = React.useState([]);
  const [showAddressSelection, setShowAddressSelection] = React.useState(false);
  // Contact Person management (same pattern as address)
  const [availableContacts, setAvailableContacts] = React.useState([]);
  const [showContactSelection, setShowContactSelection] = React.useState(false);
  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));

    if (key == "gstType") {
      updateQuoObject("gstType", value);
    }
  };

  const fetchClientList = async () => {
    try {
      const query = `select * from clients where status = 1`;
      const clientList = await fetchQuery(query);
      let pushArray = [];
      clientList?.map((client) => {
        pushArray.push({
          id: client.id,
          label: client.companyName + (client.uniCode ? ` (${client.uniCode})` : "") + (client.type ? ` (${clienTypes.find(c => c.value == client.type)?.short || ""})` : ""),
          contact: client.contact,
          address: client.address,
          companyName: client.companyName,
          logopath: client?.logopath,
          gstNumber: client?.gstNumber
        });
      });
      setClientList(pushArray);
    } catch (error) {
      console.error("Error fetching clientList:", error);
    }
  };

  // Fixed: was destructuring `[employee]` which only grabbed the first row
  // as a single object instead of the full array.
  const fetchEmployeeDetails = async () => {
    try {
      const query = `select * from employees where status = 1`;
      const employees = await fetchQuery(query);
      setEmployeeList(employees || []);

      const technicalEmployees = await fetchQuery(` SELECT e.* FROM employees e LEFT JOIN employeeOtherData eo ON eo.employeeId = e.id WHERE e.status = 1 AND eo.hrDesignation = 'Inspector'`);
      setTechnicalEmployeeList(technicalEmployees || []);
    } catch (error) {
      console.error("Error fetching employee details:", error);
    }
  };

  const fetchClientData = async () => {
    const currentClient = clientList?.find((i) => i.id == inputStates?.clientId);
    if (!currentClient) return;

    // ---- Contact Person handling (mirrors address handling below) ----
    let contactsArray = [];
    try {
      contactsArray = JSON.parse(currentClient.contact || "[]");
    } catch (e) {
      contactsArray = [];
    }

    if (contactsArray.length === 1) {
      const [c] = contactsArray;
      setInputStates((prev) => ({
        ...prev,
        contact: c?.contactPersonName || "",
        emailId: c?.emailId || "",
        contactNumber: c?.contact || "",
        contactDept: c?.dept || "",
        contactPerson: buildContactPersonJSON(
          c?.dept,
          c?.contactPersonName,
          c?.contact,
          c?.emailId
        ),
      }));
      setShowContactSelection(false);
      setAvailableContacts([]);
    } else if (contactsArray.length > 1) {
      const formattedContacts = contactsArray.map((c, index) => ({
        id: index + 1, // avoid 0 - falsy value causes selection bugs in AutoCompletes
        dept: c?.dept || "",
        contactPersonName: c?.contactPersonName || "",
        contact: c?.contact || "",
        emailId: c?.emailId || "",
        displayName: `${c?.contactPersonName || ""}${c?.dept ? ` (${c.dept})` : ""}`,
      }));
      setAvailableContacts(formattedContacts);
      setShowContactSelection(true);
      setInputStates((prev) => ({
        ...prev,
        ...(params.id == 0 && {
          selectedContactId: null,
          contact: "",
          emailId: "",
          contactNumber: "",
          contactDept: "",
          contactPerson: "",
        }),
      }));
    } else {
      setShowContactSelection(false);
      setAvailableContacts([]);
    }

    try {
      // Fetch all addresses for the client (only billing addresses)
      const addresses = await fetchAddresses(currentClient?.address);

      if (addresses.length === 1) {
        // Single address - auto-populate
        const [currentAddress] = addresses;
        setInputStates((prev) => ({
          ...prev,
          address: currentAddress?.address || "",
          companyName: currentClient?.companyName || "",
          addressId: currentAddress?.id || "",
          logopath: currentClient?.logopath || null,
        }));
        setShowAddressSelection(false);
        setAvailableAddresses([]);
      } else if (addresses.length > 1) {
        // Multiple addresses - show selection
        const formattedAddresses = addresses.map((addr, index) => ({
          id: addr.id,
          address: addr.address,
          displayAddress: `${addr.address?.substring(0, 50)}${addr.address?.length > 50 ? "..." : ""
            }`,
        }));

        setAvailableAddresses(formattedAddresses);
        setShowAddressSelection(true);

        // Set basic client info but leave addresses empty for selection
        setInputStates((prev) => ({
          ...prev,
          companyName: currentClient?.companyName || "",
          ...(params.id == 0 && { addressId: null }),
        }));
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  useEffect(() => {
    if (
      inputStates?.selectedBillingAddressId &&
      availableAddresses.length > 0
    ) {
      const selectedAddress = availableAddresses.find(
        (addr) => addr.id === inputStates.selectedBillingAddressId
      );
      if (selectedAddress) {
        setInputStates((prev) => ({
          ...prev,
          address: selectedAddress.address,
          addressId: selectedAddress.id,
        }));
      }
    }
  }, [inputStates?.selectedBillingAddressId, availableAddresses]);

  useEffect(() => {
    if (inputStates?.selectedContactId !== undefined && inputStates?.selectedContactId !== null && availableContacts.length > 0) {
      const selectedContact = availableContacts.find((c) => c.id === inputStates.selectedContactId);
      if (selectedContact) {
        setInputStates((prev) => ({
          ...prev,
          contact: selectedContact.contactPersonName,
          emailId: selectedContact.emailId,
          contactNumber: selectedContact.contact,
          contactDept: selectedContact.dept,
          contactPerson: buildContactPersonJSON(
            selectedContact.dept,
            selectedContact.contactPersonName,
            selectedContact.contact,
            selectedContact.emailId
          ),
        }));
      }
    }
  }, [inputStates?.selectedContactId, availableContacts]);

  useEffect(() => {
    if (!inputStates?.clientId) return;
    fetchClientData();
  }, [inputStates?.clientId]);

  useEffect(() => {
    fetchClientList();
    fetchEmployeeDetails();
  }, []);

 const fetchEnquiryData = async (enquiryId) => {
  try {
    const [enquiry] = await fetchQuery(`select * from enquiry where id = ${enquiryId}`);
    if (!enquiry) return;
    setInputStates((prev) => ({
      ...prev,
      clientId: enquiry.customerName || "",
      address: enquiry.address || "",
      contact: enquiry.contactPerson || "",
      contactNumber: enquiry.customer_contact_number || "",
      emailId: enquiry.customer_email_id || "",
      enquiryReference: enquiry.enquiryNo || "",
      enquiryId: enquiry.id,
    }));
  } catch (error) {
    console.error("Error fetching enquiry data:", error);
  }
};

  useEffect(() => {
    if (params.id == 0 && fromEnquiryId) {
      fetchEnquiryData(fromEnquiryId);
    }
  }, [fromEnquiryId]);


  var refresh = () => {
    window.location.reload(false);
  };

  const fetchquotationtDetails = async () => {
    try {
      const query = `select * from quotation where id = ${params.id}`;
      const [quotation] = await fetchQuery(query);
      const requiredKeys = [...formFieldKeys, "id", "enquiryId", "paymentTerms", "termsConditions", "clientScope", "deliverables", "quotationValidity", "scopeOfThirdParty", "scopeInspectionLocation", "commercialsContactPerson", "inspection", "TechnicalContact", "professionalfees", "communicationProtocol", "Coordination", "inspectionservice", "subject", "scopeWork"];

      const filteredQuotation = Object.keys(quotation)
        .filter((key) => requiredKeys.includes(key))
        .reduce((obj, key) => {
          obj[key] = quotation[key];
          return obj;
        }, {});

    // address is already plain text now — no lookup needed

      if (filteredQuotation.contactPerson) {
        try {
          const parsedContact = JSON.parse(filteredQuotation.contactPerson);
          const c = Array.isArray(parsedContact) ? parsedContact[0] : parsedContact;
          filteredQuotation.contact = c?.contactPersonName || "";
          filteredQuotation.emailId = c?.emailId || "";
          filteredQuotation.contactNumber = c?.contact || "";
          filteredQuotation.contactDept = c?.dept || "";
        } catch (e) {
          console.error("Error parsing contactPerson:", e);
        }
      }

      const revNum = quotation?.revisionNumber;
      const revSuffix = revNum > 0 ? `-Rev-${revNum}` : "";
      filteredQuotation.quotationNumber = `${filteredQuotation.quotationNumber}${revSuffix}`;

      setInputStates(filteredQuotation);
    updateQuotationObject((prev) => ({
        ...prev,
        discount: quotation?.discount || "",
        fileUpload: quotation?.fileUpload || "",
        revisionNumber: quotation?.revisionNumber ?? 0,
        gstType: quotation?.gstType || 1,
        GSTPercentage: quotation?.gstpercentages || 18,
      }));
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  useEffect(() => {
    if (params.id == 0) {
      // default data
      updateInputObject("subject", "Quotation for Third Party Inspection Services at Vendor Location mentioned in enquiry.");
      updateInputObject("paymentTerms",
        `Invoice will be raised on monthly basis and payment toward same shall be settled within 30 days.`
      );
      updateInputObject("quotationValidity",
        `Our offer shall be valid for 30 days from the date of offer.`
      );
      updateInputObject("termsConditions", `The GENERAL TERMS AND CONDITIONS DYC/FMT-MR/29 Rev. 00, dated 24.05.2023 of DYC Global attached separately with this quotation.

In addition, DYC Global general terms and conditions including limitation of liability shall be applicable. Upon acceptance of an order a contract in the specified format of DYC Global would be agreed with you.

We trust you will find the above offer competitive and realistic to provide required level of service and look forward to be associated with you in this prestigious project. In case you need any further clarifications / comments, please contact us, we will be pleased to furnish the same promptly.`);
    }

    if (params.id != 0) {
      fetchquotationtDetails();
    }
  }, [params.id]);

  const handleSubmit = async () => {
    const {
      id, contact, companyName, contactNumber, emailId, addressId, selectedBillingAddressId, logopath,
      contactDept, selectedContactId,
      quotationNumber: rawQuotationNumber,
      ...restInputStates } = inputStates;

    // Note: contactPerson (the JSON blob) is intentionally NOT destructured
    // out above, so it flows through in restInputStates and gets saved.

    const cleanQuotationNumber = rawQuotationNumber?.replace(/-Rev-\d+$/, "");
    // Step 1: Validate required fields

    const required = [
      { value: inputStates.clientId, label: "Company Name is required" },
      { value: inputStates.address, label: "Address is required" },
      { value: inputStates.date, label: "Date is required" },
      { value: inputStates.gstType, label: "GST Type is required" },
      { value: inputStates.gstpercentages, label: "GST Percentage is required" },
      { value: inputStates.inspection, label: "Inspection is required" },
      { value: inputStates.commercialsContactPerson, label: "Commercial is required" },
      { value: inputStates.professionalfees, label: "Professional Fees is required" },
    ];
    if (!validateRequiredFields(required)) return;

    const payload = {
      ...restInputStates,
      contactPerson: buildContactPersonJSON(
        inputStates.contactDept,
        inputStates.contact,
        inputStates.contactNumber,
        inputStates.emailId
      ),
      enquiryId: inputStates.enquiryId || fromEnquiryId || null,
      date: inputStates.date ? moment(inputStates.date).format("YYYY-MM-DD") : null,
      discount: quotationObject.discount || null,
      createdBy: userId,
      quotationNumber: cleanQuotationNumber,
    };

    try {
      if (params.id != 0) {
        await axiosWithToken.patch(`${BASE_URL}quotation/${params.id}`, payload);
        toast("Quotation updated successfully!");
      } else {
        await axiosWithToken.post(`${BASE_URL}quotation`, payload);
        toast("Quotation created successfully!");
      }

      setTimeout(() => navigate("/quotationList"), 500);
    } catch (error) {
      console.error("Error submitting quotation:", error);
    }
  };

  const updateQuoObject = (key, value) => {
    let newQuoObject = {
      ...quotationObject,
    };
    newQuoObject[key] = value;
    updateQuotationObject({ ...newQuoObject });
  };

  const fetchLAstQuotation = async () => {
    try {
      const query = `select count(1) as count from quotation where status = 1`;
      const result = await fetchQuery(query);
      return result[0]?.count || 0;
    } catch (error) {
      console.error("Error fetching inspection item count:", error);
      return 0;
    }
  };

  useEffect(() => {
  const generateQuotationNumber = async () => {
    const count = await fetchLAstQuotation();
    const newCount = count + 1;
    const companyPrefix = UnicodeCompany;
      const fy = `${moment().subtract(1, "year").format("YY")}-${moment().format("YY")}`;
      updateInputObject("quotationNumber", `${companyPrefix}/QTN/${fy}/${newCount}`);
    };

    if (params.id == 0) {
      generateQuotationNumber();
    }
  }, [params.id]);

  // useEffect(() => {
  //   let currentClient = clientList?.find((i) => i.id == inputStates.clientId);
  //   const generateQuotationNumber = async () => {
  //     const count = await fetchLAstQuotation();
  //     const newCount = count + 1;
  //     // let companyNames = currentClient?.companyName?.trim();
  //     // if (companyNames) {
  //     //   const words = companyNames.split(/\s+/); // Split by spaces
  //     //   if (words.length > 1) {
  //     //     // Step 2: If multiple words, take initials
  //     //     companyNames = words.map((word) => word[0].toUpperCase()).join("");
  //     //   } else {
  //     //     // Step 3: If single word, take first 3 letters
  //     //     companyNames = companyNames.substring(0, 3).toUpperCase();
  //     //   }
  //     // }
  //     const companyPrefix = UnicodeCompany;
  //     // const quotationNumberCreate = `${companyPrefix}/${companyNames}/25-26/${newCount}`;
  //     // const quotationNumberCreate = `${companyPrefix}/QTN/25-26/${newCount}`;
  //     const fy = `${moment().subtract(1, "year").format("YY")}-${moment().format("YY")}`;
  //     const quotationNumberCreate = `${companyPrefix}/QTN/${fy}/${newCount}`;
  //     updateInputObject("quotationNumber", quotationNumberCreate);
  //   };

  //   if (currentClient?.companyName && params.id == 0) {
  //     generateQuotationNumber();
  //   }
  //   currentClient?.gstNumber && updateInputObject("gstType", currentClient.gstNumber.startsWith("27") ? 1 : 2);

  // }, [params.id, inputStates?.clientId]);

  // ---- Employee dropdown options (name + email) for Inspection / Commercials ----
  const employeeOptions = React.useMemo(() =>
      (employeeList || []).map((e) => {
        const emailForDisplay = e.officeEmailAddress || e.emailAddress || "";
        return {
          id: e.id,
          label: `${e.name?.trim() || ""}${emailForDisplay ? ` (${emailForDisplay})` : ""}`,
        };
      }),
    [employeeList]
  );

  // Renders a multi-select employee dropdown using the custom AutoCompletes
  const renderEmployeeMultiSelect = (label, stateKey) => {
    const selectedValues = (inputStates[stateKey] || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    return (
      <AutoCompletes
        label={label}
        options={employeeOptions}
        valueKey="label"
        labelKey="label"
        multiple
        value={selectedValues}
        onChange={(values) => updateInputObject(stateKey, values.join(", "))}
        disabled={PrintView}
      />
    );
  };

  return (
    <div>
      {!PrintView && (
        <Text variant="h3" bold className="text-blue-600">
          {params.id == 0 ? "Create New Quotation" : `Update Quotation`}
        </Text>
      )}
      <br />

      {/* ---- Inline replacement for CommonForm ---- */}
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {/* <AutoCompletes
          label="Company Name"
          options={clientList}
          valueKey="id"
          labelKey="label"
          value={inputStates.clientId || ""}
          onChange={(val) => updateInputObject("clientId", val)}
          disabled={params.id != 0}
        />

        {showAddressSelection && availableAddresses.length > 1 && params.id == 0 ? (
          <AutoCompletes
            label="Select Billing Address"
            options={availableAddresses}
            valueKey="id"
            labelKey="displayAddress"
            value={inputStates.selectedBillingAddressId || ""}
            onChange={(val) => updateInputObject("selectedBillingAddressId", val)}
          />
        ) : (
          <TextFields
            label="Billing Address"
            value={inputStates.address || ""}
            disabled
          />
        )}

        {showContactSelection && availableContacts.length > 1 && params.id == 0 ? (
          <AutoCompletes
            label="Select Contact Person"
            options={availableContacts}
            valueKey="id"
            labelKey="displayName"
            value={inputStates.selectedContactId ?? ""}
            onChange={(val) => updateInputObject("selectedContactId", val)}
          />
        ) : (
          <TextFields
            label="Contact Person"
            value={`${inputStates.contact || ""}${inputStates.contactDept ? ` (${inputStates.contactDept})` : ""}`}
            disabled
          />
        )} */}

        <TextFields
          label="Company Name *"
          value={inputStates.clientId || ""}
          onChange={(e) => updateInputObject("clientId", e.target.value)}
          disabled={PrintView}
        />

        <TextFields
          label="Billing Address *"
          value={inputStates.address || ""}
          onChange={(e) => updateInputObject("address", e.target.value)}
          disabled={PrintView}
        />

        <TextFields
          label="Contact Person"
          value={inputStates.contact || ""}
          onChange={(e) => updateInputObject("contact", e.target.value)}
          disabled={PrintView}
        />

        <TextFields
          label="Contact Number"
          value={inputStates.contactNumber || ""}
          onChange={(e) => updateInputObject("contactNumber", e.target.value)}
          disabled={PrintView}
        />

        <TextFields
          label="Email ID"
          value={inputStates.emailId || ""}
          onChange={(e) => updateInputObject("emailId", e.target.value)}
          disabled={PrintView}
        />

        <TextFields
          label="Quotation Number *"
          value={inputStates.quotationNumber || ""}
          onChange={(e) => updateInputObject("quotationNumber", e.target.value)}
          disabled
        />

        <DateInput
          label="Date *"
          value={inputStates.date ? new Date(inputStates.date) : ""}
          onChange={(date) =>
            updateInputObject("date", date ? format(date, "yyyy-MM-dd") : "")
          }
        />

        <AutoCompletes
          label="GST Type *"
          options={gstTypes}
          valueKey="id"
          labelKey="label"
          value={inputStates.gstType || ""}
          onChange={(val) => updateInputObject("gstType", val)}
          disabled={PrintView}
        />

        <AutoCompletes
          label="GST Percentage *"
          options={gstPercentageOptions}
          valueKey="id"
          labelKey="label"
          value={inputStates.gstpercentages || ""}
          onChange={(val) => updateInputObject("gstpercentages", val)}
          disabled={PrintView}
        />

        {/* <TextFields
          label="Ref. No. Enquiry"
          value={inputStates.refNoEnquiry || ""}
          onChange={(e) => updateInputObject("refNoEnquiry", e.target.value)}
          disabled={PrintView}
        /> */}
      </div>
      {/* ---- End inline replacement ---- */}

      <div className="mt-5 grid grid-cols-1 gap-4">
        <TextFields
          id="subject"
          multiline
          label="Subject"
          value={inputStates.subject || ""}
          onChange={(e) =>
            updateInputObject("subject", e.target.value)
          }
          disabled={PrintView}
        />
        <TextFields
          label="Reference"
          value={inputStates.enquiryReference || ""}
          onChange={(e) => updateInputObject("enquiryReference", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="scopeWork"
          multiline
          label="Scope of Work"
          value={inputStates.scopeWork || ""}
          onChange={(e) => updateInputObject("scopeWork", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="deliverables"
          multiline
          label="Deliverables"
          value={inputStates.deliverables || ""}
          onChange={(e) => updateInputObject("deliverables", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="communicationProtocol"
          multiline
          label="Communication Protocol"
          value={inputStates.communicationProtocol || ""}
          onChange={(e) => updateInputObject("communicationProtocol", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="Coordination"
          multiline
          label="Coordination"
          value={inputStates.Coordination || ""}
          onChange={(e) => updateInputObject("Coordination", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="inspectionservice"
          multiline
          label="Inspection Service"
          value={inputStates.inspectionservice || ""}
          onChange={(e) => updateInputObject("inspectionservice", e.target.value)}
          disabled={PrintView}
        />

        {/* Inspection - employee multi-select dropdown (name + email), saved comma-separated */}
        {renderEmployeeMultiSelect("Inspection *", "inspection")}

        {/* Commercials - employee multi-select dropdown (name + email), saved comma-separated */}
        {renderEmployeeMultiSelect("Commercials *", "commercialsContactPerson")}

        <AutoCompletes
          label="Technical"
          options={(technicalEmployeeList || []).map((e) => ({
            id: e.id,
            label: `${e.name}${e.officeEmailAddress ? ` (${e.officeEmailAddress})` : ""}`,
          }))}
          valueKey="label"
          labelKey="label"
          multiple
          value={(inputStates.TechnicalContact || "")
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)}
          onChange={(values) =>
            updateInputObject("TechnicalContact", values.join(", "))
          }
          disabled={PrintView}
        />
        <TextFields
          id="professionalfees"
          multiline
          label="Professional Fees *"
          value={inputStates.professionalfees || ""}
          onChange={(e) => updateInputObject("professionalfees", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="paymentTerms"
          multiline
          label="Payment Terms"
          value={inputStates.paymentTerms || ""}
          onChange={(e) => updateInputObject("paymentTerms", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="quotationValidity"
          multiline
          label="Validity"
          value={inputStates.quotationValidity || ""}
          onChange={(e) => updateInputObject("quotationValidity", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="termsConditions"
          multiline
          label="Terms Conditions"
          value={inputStates.termsConditions || ""}
          onChange={(e) => updateInputObject("termsConditions", e.target.value)}
          disabled={PrintView}
        />
      </div>

      <br />
      <br />

      {!PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />
          {(permissions.save || permissions.create || permissions.allAccess) && (
            <SaveAndUpdate
              id="btn-add-outline"
              label={params.id == 0 ? "Save" : "Update"}
              onClick={handleSubmit}
            />
          )}
        </div>
      )}
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Report"}
        />
      )}
    </div>
  );
}